import PromotionCreate from './Create'
import PromotionEdit from './Edit'
import promotionsList from './List'
import PromotionShow from './Show'



const promotionsResource = {
  show: PromotionShow,
  list: promotionsList,
  create: PromotionCreate,
  edit: PromotionEdit,
}

export default promotionsResource
